import { useMutation } from '@tanstack/react-query';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';
import { deleteHomeLinksRequest } from '../requests/deleteHomeLinksRequest';

export function useDeleteHomeLinks() {
	const deleteHomeLinks = useMutation({
		mutationFn: async (id: number) => {
			return deleteHomeLinksRequest(id);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully deleted!', type: 'success' });
			queryClient.invalidateQueries(['HOME_LINKS']);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { deleteHomeLinks };
}
